
// Add smooth scrolling to expanded sections
document.addEventListener('DOMContentLoaded', function() {
    const accordionButtons = document.querySelectorAll('.accordion-button');
    
    // Create save status indicators for each textarea
    const reflectionAnswers = document.querySelectorAll('.reflection-answer');
    
    reflectionAnswers.forEach(function(textarea) {
        // Create save status indicator
        const saveStatus = document.createElement('div');
        saveStatus.className = 'save-status mt-1';
        saveStatus.style.display = 'none';
        textarea.parentNode.insertBefore(saveStatus, textarea.nextSibling);
        
        // Load saved response
        const savedValue = localStorage.getItem(textarea.id);
        if (savedValue) {
            textarea.value = savedValue;
        }
        
        // Add autosave with visible feedback
        let saveTimeout;
        textarea.addEventListener('input', function() {
            clearTimeout(saveTimeout);
            saveStatus.textContent = 'Saving...';
            saveStatus.style.display = 'block';
            
            saveTimeout = setTimeout(() => {
                localStorage.setItem(textarea.id, textarea.value);
                saveStatus.textContent = 'Saved';
                
                // Hide the saved message after 3 seconds
                setTimeout(() => {
                    saveStatus.style.opacity = '0';
                    setTimeout(() => {
                        saveStatus.style.display = 'none';
                        saveStatus.style.opacity = '1';
                    }, 500);
                }, 3000);
            }, 1000);
        });
    });

    // Handle accordion scrolling
    accordionButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Wait for the collapse animation to complete
            setTimeout(() => {
                if (!this.classList.contains('collapsed')) {
                    const headerOffset = 100;
                    const elementPosition = this.getBoundingClientRect().top;
                    const offsetPosition = elementPosition - headerOffset;

                    window.scrollBy({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 350);
        });
    });

    // Add keyboard navigation
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
        const button = item.querySelector('.accordion-button');

        button.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });
});
